// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .Hs_flexboxtitle__iODj1 {
    display: flex;
    justify-content: space-between;
    width: 50%;
  }

  .Hs_flexbox__-lSft {
    display: flex;
    justify-content: space-between;
    width: 50%;
  }

  .Hs_flexbox100__Nul6v {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .Hs_button__LbZPd {
    background-color: #41ab44;
    border: none;
    color: white;
    padding: 4px 8px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    transition-duration: 0.4s;
    cursor: pointer;
    border-radius: 3px;
  }

  .Hs_buttonnew__ZbYYa {
    background-color: #41ab44;
    color: white;
    border: 1px solid #41ab44;
  }

  .Hs_buttonnew__ZbYYa:hover {
    background-color: white;
    color: black;
  }

  .Hs_buttonproses__Zhr-a {
    background-color: #418bab;
    color: white;
    border: 1px solid #418bab;
  }

  .Hs_buttonproses__Zhr-a:hover {
    background-color: white;
    color: black;
  }

  .Hs_buttonload__yeizl {
    background-color: #e26724;
    color: white;
    border: 1px solid #e26724;
  }

  .Hs_buttonload__yeizl:hover {
    background-color: white;
    color: black;
  }

  /* InputStyles.module.css */
  input {
    font-size: 1rem !important;
    /* box-sizing: content-box !important;
    width: -webkit-fill-available !important; */
    height: auto;
    margin: 5px !important;
    padding: 0 !important;
    transition: box-shadow 0.3s, border 0.3s;
    border: none !important;
    border-radius: 5px !important;
    border: 1px solid rgb(190, 190, 190) !important;
    background-color: rgb(255, 255, 255) !important;
    outline: none !important;
    box-shadow: none !important;
  }

  input[type=search]:not(.Hs_browser-default__o2Pal){
    width: 80% !important;
    padding: 4px !important;
  }

  .Hs_positionfixduplicatetable__npAQI {
    overflow: auto;
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 900;
    width: 100%;
    background-color: #eff6ff;
    height: 300px !important;
    border-top: 2px solid #ccc;
  }

  .Hs_positionbankpembayaran__1q\\+Xi {
    overflow: hidden;
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 900;
    width: 100%;
    background-color: #eff6ff;
    height: 350px !important;
    border-top: 2px solid #ccc;
  }

  .Hs_container2layout__GtW5T {
    display: table !important;
    width: 100% !important;
  }

  .Hs_leftcontainer2layout__mUP3N {
    position: absolute !important;
    left: 0px !important;
    width: 50% !important;
    border-right: solid 0.5px rgb(229, 229, 229) !important;
    text-align: left;
  }

  .Hs_rightcontainer2layout__m6R-a {
    position: absolute !important;
    right: 0px !important;
    width: 50% !important;
    border-left: solid 0.5px rgb(229, 229, 229) !important;
    text-align: left;
  }

  .Hs_titleduplicate__m9EBG {
    margin: 5px !important;
  }

  .Hs_title__nUC8u {
    margin-right: 10px !important;
    color: #505050 !important;
  }

  .Hs_h4__IWqxA {
    font-size: 1.08rem !important;
    line-height: 110% !important;
    margin: 1.14rem 0 0.912rem 0 !important;
    font-weight: 600 !important;
  }

  button {
    line-height: auto !important;
  }

  .Hs_margintable__P9e94 {
    margin: 8px;
  }

  .Hs_styleTotalTitle__J7kfo{
    font-size: 14px;
    font-weight: bold;
    margin: 10px 0px 10px 10px;
    padding: 1px;
  }

  .Hs_styleTotal__dgOWM{
    font-size: 14px;
    font-weight: bold;
    margin: 10px 10px 10px 0px;
    padding: 1px;
  }

  /*================== */
  .Hs_inputText__AoSJn{
    padding: 4px !important;
    margin: 0px 0  !important;
    box-sizing: border-box  !important;
    border: 1px solid rgb(171 165 165)  !important;
    border-radius: 3px  !important;
    text-align: center  !important;
    font-weight: 500  !important;
    color: #505050  !important;
    width: 2% !important;
}

.Hs_modal__Vhbit .Hs_inputTextFilter__WXeNI {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 4px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/css/Hs.module.css"],"names":[],"mappings":"EAAE;IACE,aAAa;IACb,8BAA8B;IAC9B,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA,2BAA2B;EAC3B;IACE,0BAA0B;IAC1B;+CAC2C;IAC3C,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,wCAAwC;IACxC,uBAAuB;IACvB,6BAA6B;IAC7B,+CAA+C;IAC/C,+CAA+C;IAC/C,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,UAAU;IACV,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,UAAU;IACV,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,qBAAqB;IACrB,uDAAuD;IACvD,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,qBAAqB;IACrB,qBAAqB;IACrB,sDAAsD;IACtD,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;IAC5B,uCAAuC;IACvC,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;EACd;;EAEA,sBAAsB;EACtB;IACE,uBAAuB;IACvB,yBAAyB;IACzB,kCAAkC;IAClC,8CAA8C;IAC9C,8BAA8B;IAC9B,8BAA8B;IAC9B,4BAA4B;IAC5B,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":["  .flexboxtitle {\n    display: flex;\n    justify-content: space-between;\n    width: 50%;\n  }\n\n  .flexbox {\n    display: flex;\n    justify-content: space-between;\n    width: 50%;\n  }\n\n  .flexbox100 {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .button {\n    background-color: #41ab44;\n    border: none;\n    color: white;\n    padding: 4px 8px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    margin: 4px 2px;\n    transition-duration: 0.4s;\n    cursor: pointer;\n    border-radius: 3px;\n  }\n\n  .buttonnew {\n    background-color: #41ab44;\n    color: white;\n    border: 1px solid #41ab44;\n  }\n\n  .buttonnew:hover {\n    background-color: white;\n    color: black;\n  }\n\n  .buttonproses {\n    background-color: #418bab;\n    color: white;\n    border: 1px solid #418bab;\n  }\n\n  .buttonproses:hover {\n    background-color: white;\n    color: black;\n  }\n\n  .buttonload {\n    background-color: #e26724;\n    color: white;\n    border: 1px solid #e26724;\n  }\n\n  .buttonload:hover {\n    background-color: white;\n    color: black;\n  }\n\n  /* InputStyles.module.css */\n  input {\n    font-size: 1rem !important;\n    /* box-sizing: content-box !important;\n    width: -webkit-fill-available !important; */\n    height: auto;\n    margin: 5px !important;\n    padding: 0 !important;\n    transition: box-shadow 0.3s, border 0.3s;\n    border: none !important;\n    border-radius: 5px !important;\n    border: 1px solid rgb(190, 190, 190) !important;\n    background-color: rgb(255, 255, 255) !important;\n    outline: none !important;\n    box-shadow: none !important;\n  }\n\n  input[type=search]:not(.browser-default){\n    width: 80% !important;\n    padding: 4px !important;\n  }\n\n  .positionfixduplicatetable {\n    overflow: auto;\n    position: fixed;\n    bottom: 0px;\n    right: 0px;\n    z-index: 900;\n    width: 100%;\n    background-color: #eff6ff;\n    height: 300px !important;\n    border-top: 2px solid #ccc;\n  }\n\n  .positionbankpembayaran {\n    overflow: hidden;\n    position: fixed;\n    bottom: 0px;\n    right: 0px;\n    z-index: 900;\n    width: 100%;\n    background-color: #eff6ff;\n    height: 350px !important;\n    border-top: 2px solid #ccc;\n  }\n\n  .container2layout {\n    display: table !important;\n    width: 100% !important;\n  }\n\n  .leftcontainer2layout {\n    position: absolute !important;\n    left: 0px !important;\n    width: 50% !important;\n    border-right: solid 0.5px rgb(229, 229, 229) !important;\n    text-align: left;\n  }\n\n  .rightcontainer2layout {\n    position: absolute !important;\n    right: 0px !important;\n    width: 50% !important;\n    border-left: solid 0.5px rgb(229, 229, 229) !important;\n    text-align: left;\n  }\n\n  .titleduplicate {\n    margin: 5px !important;\n  }\n\n  .title {\n    margin-right: 10px !important;\n    color: #505050 !important;\n  }\n\n  .h4 {\n    font-size: 1.08rem !important;\n    line-height: 110% !important;\n    margin: 1.14rem 0 0.912rem 0 !important;\n    font-weight: 600 !important;\n  }\n\n  button {\n    line-height: auto !important;\n  }\n\n  .margintable {\n    margin: 8px;\n  }\n\n  .styleTotalTitle{\n    font-size: 14px;\n    font-weight: bold;\n    margin: 10px 0px 10px 10px;\n    padding: 1px;\n  }\n\n  .styleTotal{\n    font-size: 14px;\n    font-weight: bold;\n    margin: 10px 10px 10px 0px;\n    padding: 1px;\n  }\n\n  /*================== */\n  .inputText{\n    padding: 4px !important;\n    margin: 0px 0  !important;\n    box-sizing: border-box  !important;\n    border: 1px solid rgb(171 165 165)  !important;\n    border-radius: 3px  !important;\n    text-align: center  !important;\n    font-weight: 500  !important;\n    color: #505050  !important;\n    width: 2% !important;\n}\n\n.modal .inputTextFilter {\n  width: 100%;\n  padding: 8px;\n  margin-top: 5px;\n  border: 4px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexboxtitle": `Hs_flexboxtitle__iODj1`,
	"flexbox": `Hs_flexbox__-lSft`,
	"flexbox100": `Hs_flexbox100__Nul6v`,
	"button": `Hs_button__LbZPd`,
	"buttonnew": `Hs_buttonnew__ZbYYa`,
	"buttonproses": `Hs_buttonproses__Zhr-a`,
	"buttonload": `Hs_buttonload__yeizl`,
	"browser-default": `Hs_browser-default__o2Pal`,
	"positionfixduplicatetable": `Hs_positionfixduplicatetable__npAQI`,
	"positionbankpembayaran": `Hs_positionbankpembayaran__1q+Xi`,
	"container2layout": `Hs_container2layout__GtW5T`,
	"leftcontainer2layout": `Hs_leftcontainer2layout__mUP3N`,
	"rightcontainer2layout": `Hs_rightcontainer2layout__m6R-a`,
	"titleduplicate": `Hs_titleduplicate__m9EBG`,
	"title": `Hs_title__nUC8u`,
	"h4": `Hs_h4__IWqxA`,
	"margintable": `Hs_margintable__P9e94`,
	"styleTotalTitle": `Hs_styleTotalTitle__J7kfo`,
	"styleTotal": `Hs_styleTotal__dgOWM`,
	"inputText": `Hs_inputText__AoSJn`,
	"modal": `Hs_modal__Vhbit`,
	"inputTextFilter": `Hs_inputTextFilter__WXeNI`
};
export default ___CSS_LOADER_EXPORT___;
